'use strict';

// configuration to adapt displayed exercise names for therapist / patient app and words/sentences/texts
const exerciseNames = {
  wordset: {
    Understanding: 'Verstehen' as const,
    Speaking: 'Sprechen' as const,
    Writing: 'Schreiben' as const,
    Reading: 'Lesen' as const,
  },
  sentenceset: {
    Understanding: 'Verstehen' as const,
    Speaking: 'Sprechen' as const,
    Writing: 'Schreiben' as const,
    Reading: 'Lesen' as const,
  },
  textset: {
    Understanding: 'Verstehen' as const,
    Speaking: 'Sprechen' as const,
    Writing: 'Schreiben' as const,
    Reading: 'Lesen' as const,
  },
};

type SetType = keyof typeof exerciseNames;
export type ExerciseType = 'Understanding' | 'Speaking' | 'Writing' | 'Reading';

export function getFullExerciseName(
  name: ExerciseType,
  setType: SetType,
): 'Lesen' | 'Sprechen' | 'Verstehen' | 'Schreiben' {
  return exerciseNames[setType][name];
}
